import { useEffect,useState } from 'react';

import useAxiosPrivate from './useAxiosPrivate';

const useIsExpertEsn = () => {
    const [isExpertEsn, setIsExpertEsn] = useState(null);
    const axiosPrivate = useAxiosPrivate();
    useEffect(() => {
        const fetchExpertStatus = async () => {
            try {
                const response = await axiosPrivate.get('expert/getMyInfos');
                setIsExpertEsn(!!response?.data?.expert?.esnId); // Set true if esnId exists, otherwise false
            } catch (error) {
                console.error('Error fetching ESN Expert status:', error);
                setIsExpertEsn(false); // Default to false on error
            }
        };

        fetchExpertStatus();
    }, []);

    return isExpertEsn; // Returns true, false, or null (while loading)
};
export default useIsExpertEsn;